// https://vuex.vuejs.org/en/actions.html
import axios from "axios";
import helpers from "@/helpers";
// import moment from 'moment'
// import state from './state'

const prefixPath = process.env.VUE_APP_ROOT_URL;
const userType = "NON_ADMF";
// let distType = state.distType;

// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  login({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      // commit('auth_request')
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/identity/v1/${state.distType}/login`,
          {
            fireBaseToken: "",
            login: userData.username,
            password: userData.password
          },
          {
            headers: {
              "Accept": "application/json",
              'Content-Type': 'application/json',
              "client-source-type": "CST_WEB",
              "user-type": userType,
              "distributor": state.distType,
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          const tokenWeb = response.data.token;
          const refreshTokenWeb = response.data.refreshToken;
          const usernameWeb = userData.username;
          console.log("==== usernameWeb = "+userData.username)
          // const userTypeWeb = userData.userType
          const userTypeWeb = userType;
          const tokenExpDateWeb = response.data.changeOldPassFlag;
          const refreshTokenExpDateWeb = response.data.refreshTokenExpDate;
          const changeOldPassFlag = response.data.changeOldPassFlag;
          const acceptTermCondFlag = response.data.acceptTermCondFlag;
          //cleanup
          localStorage.removeItem("login__selectedUserType"); //doesnt needed anymore

          commit("auth_success", {
            tokenWeb,
            usernameWeb,
            userTypeWeb,
            refreshTokenWeb,
            tokenExpDateWeb,
            refreshTokenExpDateWeb,
            changeOldPassFlag,
            acceptTermCondFlag,
          });
          commit("setDistType", userData.distCode);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          commit("auth_error");
          localStorage.removeItem("token");
          reject(err);
        });
    });
  },
  refreshToken({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/identity/v1/${state.distType}/refreshToken`,
          // `${prefixPath}/api/indobeauty/identity/v1/api/indobeauty/identity/v1/refreshToken`,
          {
            refreshToken: state.refreshTokenWeb,
            username: state.usernameWeb,
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              "user-type": userType,
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          const tokenWeb = response.data.token;
          const refreshTokenWeb = response.data.refreshToken;
          const usernameWeb = state.usernameWeb;
          const userTypeWeb = state.userTypeWeb;
          const tokenExpDateWeb = response.data.tokenExpDate;
          const refreshTokenExpDateWeb = response.data.refreshTokenExpDate;

          //cleanup
          localStorage.removeItem("login__selectedUserType"); //doesnt needed anymore

          // axios.defaults.headers.common['Authorization'] = tokenWeb
          // mutation to change state properties to the values passed along
          commit("auth_successRefresh", {
            tokenWeb,
            usernameWeb,
            userTypeWeb,
            refreshTokenWeb,
            tokenExpDateWeb,
            refreshTokenExpDateWeb,
          });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          commit("auth_error");
          localStorage.removeItem("token");
          reject(err);
        });
    });
  },
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");

      axios
        .post(
          // `${prefixPath}/api/indobeauty/identity/v1/${state.distType}/logout`,
          `${prefixPath}/api/indobeauty/identity/v1/${state.distType}/api/indobeauty/identity/v1/logout`,
          { login: state.username },
          {
            headers: {
              // 'Authorization': `Bearer ${localStorage.getItem('token')}`
              "client-source-type": "CST_WEB",
              "user-type": userType,
              Authorization: state.tokenWeb,
              
            },
            validateStatus: function(status) {
              // return status >= 200 && status < 600; // default
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("logout");
          commit("resetCart");
          commit("resetCheckoutItems");
          commit("resetVaProfile");
          commit("resetVaInfo");
          commit("stopLoading");
          commit("resetTransactions");
          commit("resetPromo");
          resolve(response);
        })
        .catch(function(err) {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  // forgotPass({ commit }, userData) {
  //   return new Promise((resolve, reject) => {
  //     commit("startLoading");
  //     axios
  //       .post(
  //         `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/forgotPassword`,
  //         { login: userData.username, newpassword: "" },
  //         {
  //           headers: {
  //             "client-source-type": "CST_WEB",
  //             "user-type": userData.userType, //'INTERN_SLS',
  //             
  //           },
  //           validateStatus: function(status) {
  //             return status == 200;
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         commit("forgotPassSuccess");
  //         commit("stopLoading");
  //         resolve(response);
  //       })
  //       .catch(function(error) {
  //         commit("stopLoading");
        
  //         reject(error);
  //       });
  //   });
  // },
  forgotPass({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/SMG/forgotPassword`,{},
          {
            headers: {
              "client-source-type": "CST_WEB",
              "user-type": userType, 
              
            },
            params: {
              email: userData,
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          // commit("forgotPassSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch(function(error) {
          commit("stopLoading");
        
          reject(error);
        });
    });
  },
  resetPassword({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit('startLoading')
      axios.post(`${prefixPath}/api/indobeauty/user-mgmt/v1/SMG/resetPassword`, args, {
        headers: {
          "client-source-type": "CST_WEB",
          Authorization: state.tokenWeb,
          "user-type": userType,
          
        },
        params: {
          token: args.token
        },
      })
        .then(response => {
          commit('stopLoading')
          resolve(response)
        })
        .catch(err => {
          commit('stopLoading')
          reject(err)
        })
    })
  },
  validateForgotPassword({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/SMG/validasiResetPassword`,{},
          {
            headers: {
              "client-source-type": "CST_WEB",
              "user-type": userType, 
              
            },
            params: {
              email: userData.email,
              token: userData.token
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          // commit("forgotPassSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch(function(error) {
          commit("stopLoading");
        
          reject(error);
        });
    });
  },
  changePass({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      // commit('auth_request')
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/changePassword`,
          {
            login: state.usernameWeb,
            password: userData.password,
            newpassword: userData.newPassword,
          },
          {
            headers: {
              // 'Authorization': `Bearer ${localStorage.getItem('token')}`
              "client-source-type": "CST_WEB",
              "user-type": userType, //'INTERN_SLS',
              Authorization: state.tokenWeb,
              
            },
            validateStatus: function(status) {
              // return status >= 200 && status < 600; // default
              return status == 200;
            },
          }
        )
        .then((response) => {
          // console.log(response);
          // const token = response.data.token // response.data.access_token
          // // const user = response.data.user.username // response.data.username
          // // storing jwt in localStorage. https cookie is safer place to store
          // localStorage.setItem('token', token)
          // // localStorage.setItem('user', user)
          // axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          // // mutation to change state properties to the values passed along
          // commit('auth_success', { token })
          // resolve(response)
          // commit('logout')
          // localStorage.removeItem('token')
          // localStorage.removeItem('username')
          // delete axios.defaults.headers.common['Authorization']
          // const status = response.data.status;
          // if(status == 0){
          //   const snackbarMsg = response.data.message
          //   const snackbarColor = 'red'
          //   // console.log('from actions js', snackbarText);
          //   commit('setShowSnackbar', { snackbarMsg, snackbarColor })
          // }

          // if(status == 1){
          //   const snackbarMsg = response.data.message
          //   const snackbarColor = 'green'
          //   // console.log('from actions js', snackbarText);
          //   commit('setShowSnackbar', { snackbarMsg, snackbarColor })
          // }
          commit("changePassSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          // commit('logoutError')
          reject(err);
        });
    });
  },
  // resetPin ({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     commit('auth_request')
  //     axios.post(`/api/indobeauty/virtual-account/v1/resetpin`, {
  //       'partner_code': '1002',
  //       'request_id': '123456',
  //       'lang': 'INA',
  //       'datetime': '20201009140039',
  //       'va': '9000101625089349',
  //       'email_recipient': [
  //           {
  //               'email': 'string'
  //           }
  //       ]
  //     }, {
  //       headers: {
  //         'client-source-type': 'CST_WEB',
  //         'user-type': localStorage.getItem('userType'), //'INTERN_SLS',
  //         'Authorization': localStorage.getItem('token')
  //       },
  //       validateStatus: function (status) {
  //         return status == 200
  //       },
  //     })
  //       .then((response) => {
  //         commit('changePassSuccess')
  //         resolve(response)
  //       })
  //       .catch(err => {
  //         // commit('logoutError')
  //         reject(err)
  //       })
  //   })
  // },
  resetPinLink({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      // commit('auth_request')
      commit("startLoading");
      //va dapet dari getVa
      //email recipient dapet dari profile info
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/resetpin`,
          {
            partner_code: "",
            request_id: "",
            lang: "",
            datetime: "",
            va: userData.vaNo,
            email_recipient: [
              {
                email: "string",
              },
            ],
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              "user-type": userType, //'INTERN_SLS',
              Authorization: state.tokenWeb,
              
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("changePassSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          // commit('logoutError')
          commit("stopLoading");
          reject(err);
        });
    });
  },
  changePin({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      // commit('auth_request')
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/changepin`,
          {
            partner_code: "", //kosongkan saja
            request_id: "", //kosongkan saja
            lang: "", //kosongkan saja
            datetime: "", //202010091414090039 yyyyMMddHHmmss kosongkan saja
            va: "9000101625089349", //dapet dati getVA
            old_pin: userData.pin,
            new_pin: userData.newPin,
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              "user-type": userType, //'INTERN_SLS',
              Authorization: state.tokenWeb,
              
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("changePassSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          // commit('logoutError')
          commit("stopLoading");
          reject(err);
        });
    });
  },
  editProfile({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      // commit('auth_request')
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/updateUser`,
          {
            emailExternal: userData.emailExternal,
            mobileNo: userData.mobileNo,
            pin: userData.pin,
            jenisKelamin: userData.jenisKelamin,
            noKtp: userData.noKtp,
            tglLahir: userData.tglLahir,
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              "user-type": userType, //'INTERN_SLS',
              Authorization: state.tokenWeb,
              
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("changePassSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          // commit('logoutError')
          commit("stopLoading");
          reject(err);
        });
    });
  },
  editPencairan({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      // commit('auth_request')
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/setCashoutAccount`,
          userData,
          // {
          //   'bank_account_name': userData.emailExternal,
          //   'bank_account_no': userData.emailExternal,
          //   'bank_account_type': '',
          //   'bank_bi_code': userData.emailExternal,
          //   'bank_coc_code': userData.emailExternal,
          //   'bank_name': userData.emailExternal,
          //   'datetime': '',
          //   'lang': '',
          //   'partner_code': '',
          //   'request_id': '',
          //   'va': userData.vaNo
          // }
          {
            headers: {
              "client-source-type": "CST_WEB",
              "user-type": userType, //'INTERN_SLS',
              Authorization: state.tokenWeb,
              
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("changePassSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          // commit('logoutError')
          commit("stopLoading");
          reject(err);
        });
    });
  },
  // refreshtoken ({ commit }) {
  //   axios.get('/refresh')
  //     .then(response => {
  //       const token = response.data.access_token
  //       localStorage.setItem('token', token)
  //       axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  //       commit('auth_success', { token })
  //     })
  //     .catch(() => {
  //       // console.log('refresh token error')
  //       commit('logout')
  //       localStorage.removeItem('token')
  //       // console.log(error)
  //     })
  // },
  // getTableList ({ commit }, tableName) {
  //   this.$http.get(`/${tableName}`)
  //     .then(response => {
  //       // console.log(response)
  //       let tableList = response.data.Keys
  //       commit('setTableList', { tableList })
  //     })
  //     .catch(error => console.log(error))
  // },
  // updateTableItem (tableData) {
  //   return new Promise((resolve, reject) => {
  //     let httpmethod = tableData.method
  //     axios({ url: `/${tableData.endpoint}`, method: httpmethod, data: tableData.tableItem })
  //       .then(response => {
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         // console.log(error)
  //         reject(error)
  //       })
  //   })
  // },
  // getUserList ({ commit, dispatch }, userData) {
  //   return new Promise((resolve, reject) => {
  //     // commit('auth_request')
  //     // axios.defaults.headers.common['authorization'] = `Bearer ${localStorage.getItem('token')}`
  //     let _start = (userData.currentPage - 1) * userData.perPage
  //     let linkPage = userData.currentPage === 1 ? `?_limit=${userData.perPage}` : `?_start=${_start}&_limit=${userData.perPage}`
  //     axios.get(`http://localhost:1337/users${linkPage}`, {
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('token')}`
  //       }
  //     })
  //       .then(response => {
  //         // console.log(response)
  //         let userList = response.data
  //         // const token = response.data.jwt // response.data.access_token
  //         // const user = response.data.user.username // response.data.username
  //         // storing jwt in localStorage. https cookie is safer place to store
  //         // localStorage.setItem('token', token)
  //         // localStorage.setItem('user', user)
  //         // axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  //         // mutation to change state properties to the values passed along
  //         commit('setUserList', userList)
  //         dispatch('getUserListCount')
  //         resolve(response)
  //       })
  //       .catch(err => {
  //         // console.log('get user list error')
  //         commit('userList_error')
  //         // localStorage.removeItem('token')
  //         reject(err)
  //       })
  //   })
  // },
  // getUser ({ commit }, userID) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`http://localhost:1337/users/${userID}`, {
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('token')}`
  //       }
  //     })
  //       .then(response => {
  //         let user = response.data
  //         commit('setUser', user)
  //         resolve(response)
  //       })
  //       .catch(err => {
  //         commit('user_error')
  //         reject(err)
  //       })
  //   })
  // },
  // getUserListCount ({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`http://localhost:1337/users/count`, {
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('token')}`
  //       }
  //     })
  //       .then(response => {
  //         let userListCount = response.data
  //         commit('setUserListCount', userListCount)
  //         resolve(response)
  //       })
  //       .catch(err => {
  //         commit('userListCount_error')
  //         reject(err)
  //       })
  //   })
  // },
  // createUser (userData) {
  //   return new Promise((resolve, reject) => {
  //     // commit('auth_request')
  //     axios.post('http://localhost:1337/users', userData, {
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('token')}`
  //       }
  //     })
  //       .then(response => {
  //         resolve(response)
  //       })
  //       .catch(err => {
  //         reject(err)
  //       })
  //   })
  // },
  // updateUser (userData) {
  //   return new Promise((resolve, reject) => {
  //     let userID = router.currentRoute.params.id
  //     // commit('auth_request')
  //     axios.put(`http://localhost:1337/users/${userID}`, userData, {
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('token')}`
  //       }
  //     })
  //       .then(response => {
  //         resolve(response)
  //       })
  //       .catch(err => {
  //         reject(err)
  //       })
  //   })
  // },
  // getHeaderLinks ({ commit }, page) {
  //   return new Promise(() => {
  //     let headerLinks = []
  //     switch (page) {
  //       case 'users':
  //         headerLinks = {
  //           new: {
  //             label: 'Add New User',
  //             href: '/users/add',
  //             classicon: 'mdi mdi-account-plus'
  //           }
  //         }
  //         break
  //       case 'user-add':
  //         headerLinks = {
  //           new: {
  //             label: 'User list',
  //             href: '/users',
  //             classicon: 'mdi mdi-account-multiple'
  //           }
  //         }
  //         break
  //       default:
  //         headerLinks = {}
  //         break
  //     }
  //     commit('setHeaderLinks', headerLinks)
  //   })
  // },
  // deleteUser ({dispatch}, data) {
  //   // console.log(this.currentPage)
  //   return new Promise((resolve, reject) => {
  //     axios.delete('http://localhost:1337/users/' + data.userID, {
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('token')}`
  //       }
  //     })
  //       .then(response => {
  //         dispatch('getUserList', {
  //           perPage: data.perPage,
  //           currentPage: data.currentPage
  //         })
  //         resolve(response)
  //       })
  //       .catch(err => {
  //         reject(err)
  //       })
  //   })
  // },
  TOGGLE_DRAWER({ commit }) {
    commit("toggleDrawer");
  },
  getProfile({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getUserProfile`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setProfile", { profileData: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getVA({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getVA`,
          {
            distributorCode: state.distType
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setProfile", { profileData: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  // getVaProfileJUNK ({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     commit('startLoading')
  //     axios.post(`/api/indobeauty/virtual-account/v1/profile`, {}, {
  //       headers: {
  //         'client-source-type': 'CST_WEB',
  //         'Authorization': localStorage.getItem('token'),
  //       },
  //       validateStatus: status => status == 200
  //     })
  //       .then(response => {
  //         commit('setVaProfile', { vaProfile: response.data.data })
  //         resolve(response)
  //         commit('stopLoading')
  //       })
  //       .catch(err => {
  //         commit('stopLoading')
  //         reject(err)
  //       })
  //   })
  // },
  getVaInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/getInfoVA`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
          }
        )
        .then((response) => {
          commit("setVaInfo", { vaInfoData: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getBankAccInfo({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('va no di dispatch getBankAccInfo', userData.vaNo)
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/inquiryBankAccount`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setBankAccInfo", { bankAccInfo: response.data.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getBanks({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/getListBank`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
          }
        )
        .then((response) => {
          commit("setBanks", { banks: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getBosses({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getSuperior`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
        })
        .then((response) => {
          // commit('setBanks', { banks: response.data.data })
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  initVaRegistration({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/initRegVA`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("initVaRegistrationSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((error) => {
          commit("stopLoading");
          reject(error);
        });
    });
  },
  vaRegistration({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/registrationVA`,
          {
            birth_date: userData.tanggalLahir,
            card_id: userData.noKtp,
            datetime: "",
            email: userData.emailEksternal,
            gender: userData.jenisKelamin,
            lang: "",
            msisdn: userData.noHp,
            name: userData.nama,
            oid: "",
            partner_code: "",
            request_id: "",
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("initVaRegistrationSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((error) => {
          commit("stopLoading");
          // commit('initVaRegistrationError')
          reject(error);
        });
    });
  },
  changeTitleApp({ commit }, titleApp) {
    commit("setTitleApp", titleApp);
  },
  getFeatures({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getFeature`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
          }
        )
        .then((response) => {
          commit("setFeatures", { features: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getProductPartners({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/inquiryProductPartner`,
          {
            pageNumber: 0,
            pageSize: 10,
            productPartnerName: "",
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          // console.log('action getProductPartners')
          commit("setProductPartners", { productPartners: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getProducts({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/inquiryProduct`, userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              "oid": state.profile.oid,
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          // commit("setProducts", { products: response.data.data.listData });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getPartner({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/getPartner`, userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          // commit("setProducts", { products: response.data.data.listData });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getPromo({ commit, state }, args) {
    console.log('in promo');
    console.log(state.distType);
    return new Promise((resolve, reject) => {
      commit('startLoading')
      axios.get(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getPromo`, {
        headers: {
          "client-source-type": "CST_WEB",
          Authorization: state.tokenWeb,
          "user-type": userType,
          
        },
        params: {
          internalId: args
        },
      })
        .then(response => {
          commit('stopLoading')
          resolve(response)
        })
        .catch(err => {
          commit('stopLoading')
          reject(err)
        })
    })
  },
  getDistributor({ commit,state }, args) {
    return new Promise((resolve, reject) => {
      commit('startLoading')
      axios.post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/api/indobeauty/user-mgmt/v1/getDistributor`, args, {
        headers: {
          "Accept": "application/json",
          "client-source-type": "CST_WEB",
          "user-type": userType,
        },
      })
        .then(response => {
          commit('stopLoading')
          resolve(response)
        })
        .catch(err => {
          commit('stopLoading')
          reject(err)
        })
    })
  },
  getOid({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit('startLoading')
      axios.get(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getOid`, {
        headers: {
          "client-source-type": "CST_WEB",
          Authorization: state.tokenWeb,
          "user-type": userType,
          "mobileNo": args
        },
        // params:{
        //   mobileNo: args
        // }
      })
        .then(response => {
          commit('stopLoading')
          resolve(response)
        })
        .catch(err => {
          commit('stopLoading')
          reject(err)
        })
    })
  },
  getListProductReward({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/inquiryProductReward`, userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getInitCurrProduct({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/initAddProduct`,
          {
            contractNo: userData.contractNo,
            nik: userData.nik,
            productCode: userData.productCode,
            customerTypeCode: userData.customerTypeCode,
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setInitCurrProduct", { initCurrProduct: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  addToCart({ commit, dispatch, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/addCartItem`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              "oid": state.profile.oid,
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let newCartItemRaw = response.data.data;
          // console.log('newCartItemRaw', newCartItemRaw)
          commit("addToCart", { [newCartItemRaw.internalId]: newCartItemRaw });

          dispatch("getCartList", {
            by: {
              pageNumber: 1,
              pageSize: 100,
              searchVal: "",
              status: "CIS_NEW",
            },
            isGroupedByStatus: true,
          });

          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  addToCartReward({ commit, dispatch, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/addCartItemReward`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              "oid": state.profile.oid,
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {

          dispatch("getCartListReward", {
            pageNumber: 1,
            pageSize: 100,
            searchVal: "",
            status: "CIS_NEW",
          });

          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  updateToCart({ commit, dispatch, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/editCartItem`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let newCartItemRaw = response.data.data;
          commit("addToCart", { [newCartItemRaw.internalId]: newCartItemRaw });
          dispatch("getCartList", {
            by: {
              pageNumber: 0,
              pageSize: 100,
              searchVal: "",
              status: "",
            },
            isGroupedByStatus: true,
          });

          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  deleteFromCart({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/deleteCartItem`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("deleteCartItem", userData.internalId);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getCart({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // axios.post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/viewCartItemWithImage`, userData, {
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/viewCartItem`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          //re-struct data
          let cartItemsRaw = response.data.data.listData;
          let cartItems = helpers.arrToObj(cartItemsRaw, "internalId");
          commit("setCart", { cartItems: cartItems });
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  checkoutCart({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/checkoutItem`,
          {
            listCartItemId: userData.listCartItemId,
            programId: userData.programId,
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              "oid": state.profile.oid,
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          //get checkout items details
          // console.log('asdffsda', userData.listCartItemId)
          // console.log('yayyyyyyy', userData)

          commit("addToCheckout", {
            adminFee: response.data.totalAdminFeeAmt,
            checkoutSum: response.data.totalPrice,
            checkoutItems: userData.checkoutItems,
            totalToBePaid: response.data.totalToBePaid,
          });
          // commit('updateAfterCheckoutCart', userData.listCartItemId )
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  checkoutCartReward({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/checkoutItemReward`,
          {
            checkoutItemRewardRequestList: userData.listCartItemId,
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  updateStatus({ commit, state }, request) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/status`, request, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  addOrder({ commit, state, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('data yang dikirim untuk bikin order', userData)
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/addOrder`, userData, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            "oid": state.profile.oid,
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          dispatch('countNotificationUnread');
          commit("stopLoading");
          // let newCartItemRaw = response.data.data
          // commit('addToCart', { [newCartItemRaw.internalId]: newCartItemRaw } )
          // commit('setCurrOrderSuccess', response.data)
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  addProductRewardOrder({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/addProductRewardOrder`, userData, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  cancelOrderReward({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/cancelOrderReward`, userData, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  viewRewardPoint({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/viewRewardPoint`, userData, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  addOrderReward({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/addOrderReward`, userData, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            "oid": state.profile.oid,
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  payment({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      // console.log('ngejalanin commit startloading di action payment')
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/payment`, userData, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          // console.log('adamasuk sih ke sini ', response)
          // let newCartItemRaw = response.data.data
          // commit('addToCart', { [newCartItemRaw.internalId]: newCartItemRaw } )
          commit("setPaymentSuccess");
          // console.log('ngejalanin commit stoploading di action payment')
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          // console.log('adamasuk sih ke sini ', err)
          commit("stopLoading");
          reject(err);
        });
    });
  },
  cancelOrder({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/cancelOrder`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          commit("setCancelOrderSuccess", response.data);
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getOrder({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      // console.log('ngejalanin commit startloading di action getOrder')
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getOrder`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          // console.log('ngejalanin commit stoploading di action getOrder', response)
          commit("stopLoading");
          let orderDetailsRaw = response.data.data;
          let orderDetailItemsRaw = orderDetailsRaw.orderItems;
          let orderDetailItems = helpers.arrToObj(
            orderDetailItemsRaw,
            "internalId"
          );
          let orderSum = response.data.data.totalPriceAmt;
          let promoSum = response.data.data.totalPromoAmt;
          let totalToBePaidSum = response.data.data.totalToBePaidAmt;
          let programCode = response.data.data.programCode;
          // console.log('orderDetailItems', orderDetailItems)
          // console.log('orderSum', orderSum)
          commit("setViewOrder", {
            adminFeeSum: response.data.data.adminFeeAmt,
            orderDetails: orderDetailsRaw,
            orderSum: orderSum,
            orderDetailItems: orderDetailItems,
            promoSum: promoSum,
            totalToBePaidSum: totalToBePaidSum,
            programCode: programCode,
          });
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getOrderReward({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getOrderReward`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getCartItem({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getCartItem`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          let cartDetailsRaw = response.data.data;
          commit("setViewCart", { cartDetails: cartDetailsRaw });
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getOrderItem({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getOrderItem`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getTransactionList({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/viewOrder`, args.by, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("setTransactionList", {
            transactions: response.data.data,
            isGroupedByStatus: args.isGroupedByStatus,
          });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getToken({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/payment`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            // 'Authorization': strToken,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getStatusPayment({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .get(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/${args}/status`, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            // 'Authorization': strToken,
            "user-type": userType,
            
          },
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getTransactions({ commit, state, dispatch }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/viewOrder`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          dispatch('countNotificationUnread');
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getCartList({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      // console.log('ngejalanin commit startloading di action getCartList')
      commit("startLoading");
      // console.log('tertriggerrr getChartlistnya')
      // axios.post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/viewCartItemWithImage`, args.by, {
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/viewCartItem`,
          args.by,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              // 'user-type': state.userTypeWeb,
              "user-type": userType,
              "oid": state.profile.oid,
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          let cartItemsRaw = response.data.data.listData;
          commit("setCartList", {
            cartItems: cartItemsRaw,
            isGroupedByStatus: args.isGroupedByStatus,
          });
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getCartListReward({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/viewCartItemReward`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              // 'user-type': state.userTypeWeb,
              "user-type": userType,
              "oid": state.profile.oid,
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          let cartItemsRaw = response.data.data.listData;
          commit("setCartListReward", {
            cartItems: cartItemsRaw
          });
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadEReceipt({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateEReceipt`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadEReceiptSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let pdfSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = pdfSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `e-Receipt--${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadECert({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/downloadDocument`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let files = response.data.data.listFile;
          // console.log('response.datafiles', files)
          // const file = files[1]//ambillnya yg ikhtisar
          // const file2 = files[0]
          // // console.log('kalusul', klausul)
          // let base64Data = file.base64Data
          // let base64Data2 = file2.base64Data

          for (let i = 0; i < files.length; i++) {
            let pdfSource = `data:application/octet-stream;base64,${files[i].base64Data}`;
            const link = document.createElement("a");
            link.href = pdfSource;
            link.setAttribute("download", `e-Cert--${files[i].fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }

          // if (base64Data) {
          //   let pdfSource = `data:application/octet-stream;base64,${base64Data}`
          //   const link = document.createElement('a');
          //   link.href = pdfSource;
          //   // link.setAttribute('download', `e-Cert.pdf`);
          //   link.setAttribute('download', `e-Cert--${file.fileName}`);
          //   document.body.appendChild(link);
          //   link.click();
          //   link.remove()
          // }
          // if (base64Data2) {
          //   let pdfSource = `data:application/octet-stream;base64,${base64Data2}`
          //   const link = document.createElement('a');
          //   link.href = pdfSource;
          //   // link.setAttribute('download', `e-Cert.pdf`);
          //   link.setAttribute('download', `e-Cert--${file2.fileName}`);
          //   document.body.appendChild(link);
          //   link.click();
          //   link.remove()
          // }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj1({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ1`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj2({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ2`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj3({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ3`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj4({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ4`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj5({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ5`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSalesReport({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/report/v1/downloadReportPenjualan`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadSalesReportSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `sales-report--${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  // downloadECert ({commit}, args) {
  //   return new Promise((resolve, reject) => {
  //     commit('startLoading')
  //     axios.post(`/api/indobeauty/transaction/v1/${state.distType}/generateEReceipt`, args, {
  //       headers: {
  //         'client-source-type': 'CST_WEB',
  //         'Authorization': localStorage.getItem('token'),
  //       },
  //       validateStatus: status => status == 200
  //     })
  //       .then(response => {
  //         commit('stopLoading')
  //         commit('downloadECertificateSuccess')
  //         resolve(response)
  //       })
  //       .catch(err => {
  //         commit('stopLoading')
  //         reject(err)
  //       })
  //   })
  // },
  getVaHistory({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/vaHistory`, userData, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          // console.log('xx', response.data.data)

          commit("setVaHistory", { vaHistoryData: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  inquiryCashout({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/inquiryCashout`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          commit("setVaHistory", { vaHistoryData: response.data.data });
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  paymentCashout({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/paymentCashout`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          commit("setVaHistory", { vaHistoryData: response.data.data });
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getSalesReportList({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/report/v1/viewReportPenjualan`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setSalesReportList", {
            salesReport: response.data.data,
          });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getProductPaymentType({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/getProductPaymentType`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setProductPaymentType", {
            productPaymentTypeList: response.data.data,
          });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getProductRewardByProductCode({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getProductReward`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("setProductDetails", { productDetails: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getProductByProductCode({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getProduct`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            "oid": state.profile.oid,
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("setProductDetails", { productDetails: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getCustomerType({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/getCustomerType`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setCustomerType", { customerTypeList: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getInsuranceEndDate({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/getInsuranceEndDate`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
          }
        )
        .then((response) => {
          // commit('setBanks', { banks: response.data.data })
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getTotalKumulatifPremi({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/GetTotalKumulatifPremi`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
          }
        )
        .then((response) => {
          // commit('setBanks', { banks: response.data.data })
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  searchCustomer({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/searchCustomer`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setCustomerList", {
            customerList: response.data.data,
          });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  uploadKtp({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/uploadKtp`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          // console.log("response uploadKTP Sukses", response)
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  addToCartPrimajaga({ commit, dispatch, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/addCartItemPrimajaga`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let newCartItemPrimajagaRaw = response.data.data;
          // console.log('newCartItemRaw', newCartItemRaw)
          commit("addToCart", {
            [newCartItemPrimajagaRaw.internalId]: newCartItemPrimajagaRaw,
          });

          dispatch("getCartList", {
            by: {
              pageNumber: 0,
              pageSize: 100,
              searchVal: "",
              status: "",
            },
            isGroupedByStatus: true,
          });

          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  verifikasiOTP({ commit, dispatch, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/verification`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          let newCartItemRaw = response.data.data;

          commit("addToCart", { [newCartItemRaw.internalId]: newCartItemRaw });

          dispatch("getCartList", {
            by: {
              pageNumber: 0,
              pageSize: 100,
              searchVal: "",
              status: "",
            },
            isGroupedByStatus: true,
          });

          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  kirimUlangOTP({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/resendOtp`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          // console.log("response ResendOTP Sukses", response)
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  updateToCartPrimajaga({ commit, dispatch, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/editCartItemPrimajaga`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let newCartItemRaw = response.data.data;
          commit("addToCart", { [newCartItemRaw.internalId]: newCartItemRaw });
          dispatch("getCartList", {
            by: {
              pageNumber: 0,
              pageSize: 100,
              searchVal: "",
              status: "",
            },
            isGroupedByStatus: true,
          });

          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  searchSertifikat({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/searchSertifikat`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setSertifikatList", { sertifikatList: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getSertifikatInfo({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getSertifikatInfo`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          // console.log('SHIMMY', response)
          commit("setSertifikat", { sertifikatInfo: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getInitCurrProductRecurr({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/initAddProductRecurr`,
          {
            productCode: userData.productCode,
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setInitCurrProductRecurr", {
            initCurrProductRecurr: response.data.data,
          });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  addToCartRecurr({ commit, dispatch, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/addCartItemRecurr`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let newCartItemRecurrRaw = response.data.data;
          // console.log('newCartItemRaw', newCartItemRaw)
          commit("addToCart", {
            [newCartItemRecurrRaw.internalId]: newCartItemRecurrRaw,
          });

          dispatch("getCartList", {
            by: {
              pageNumber: 0,
              pageSize: 100,
              searchVal: "",
              status: "",
            },
            isGroupedByStatus: true,
          });

          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  updateToCartRecurr({ commit, dispatch, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/editCartItemRecurr`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let newCartItemRaw = response.data.data;
          commit("addToCart", { [newCartItemRaw.internalId]: newCartItemRaw });
          dispatch("getCartList", {
            by: {
              pageNumber: 0,
              pageSize: 100,
              searchVal: "",
              status: "",
            },
            isGroupedByStatus: true,
          });

          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getInitCurrProductHisCert({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/initViewProductHisCert`,
          {
            productCode: userData.productCode,
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setInitCurrProductHisCert", {
            initCurrProductHisCert: response.data.data,
          });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getinitViewProductReqCert({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/initViewProductReqCert`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setViewModeReqCert", response.data.data);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  downloadEpolis({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/downloadEpolis`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadEPolisSuccess");
          let files = response.data.data.listFile;
          for (let i = 0; i < files.length; i++) {
            let pdfSource = `data:application/octet-stream;base64,${files[i].base64Data}`;
            const link = document.createElement("a");
            link.href = pdfSource;
            link.setAttribute("download", `e-Cert--${files[i].fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  sendEmailEPolis({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/sendEmailEpolis`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("sendEmailPolisSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getKtpById({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getKtpById`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("setKtp", { ktpData: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getInsuranceEndDateAmandira({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/getInsuranceEndDateAmandira`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getPlanById({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/GetPlanById`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getPlanPaymentPeriodById({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/GetPlanPymtPeriodById`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpajAmandira({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJAmandira`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj1Amandira({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ1Amandira`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj2Amandira({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ2Amandira`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj3Amandira({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ3Amandira`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj4Amandira({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ4Amandira`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  downloadSpaj5Amandira({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJ5Amandira`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  inquiryProgram({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/inquiryProgram`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          let programInfoRaw = response.data.data;
          programInfoRaw.forEach(function(v) {
            delete v.infoContent;
          });
          commit("setProgramInfo", programInfoRaw);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getProgram({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getProgram`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          let programInfoByIdRaw = response.data.data;
          commit("setProgramInfoById", programInfoByIdRaw);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  programNotification({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/programNotification`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let programInfoRaw = response.data.data;
          commit("setProgramNotif", programInfoRaw);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  readProgramNotification({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/readProgramNotification`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          // let programInfoRaw = response.data.data
          // commit('setReadProgramNotif', programInfoRaw)
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getInquirySalesKit({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/inquirySalesKit`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("setInquirySalesKit", response.data.data);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getSalesKit({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getSalesKit`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("setSalesKitById", response.data.data);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getSalesKitItem({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getSalesKitItem`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("setSalesKitItem", response.data.data);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getSalesKitAttach({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getSalesKitAttach`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("downloadSalesKitAttach");

          let file = response.data.data;
          // console.log("DOWNLOAD", file)
          let base64Data = file.attachFile;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute(
              "download",
              `${file.attachFileName}.${file.attachFileExt}`
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getPopupNoti({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getPopupNoti`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          let programInfoRaw = response.data.data;
          commit("setPopupNotifById", programInfoRaw);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getNotifications({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/notification`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  updateNotification({ commit, state, dispatch }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/updateNotification`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          dispatch('countNotificationUnread');
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getHistoryPoint({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/riwayatPoin`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getRiwayatPoint({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getRiwayatPoin`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            "oid": state.profile.oid,
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  popupNotification({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/popupNotification`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let programInfoRaw = response.data.data;
          commit("setPopupNotif", programInfoRaw);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  readPopupNotification({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/readPopupNotification`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          // let programInfoRaw = response.data.data
          // commit('setReadPopupNotif', programInfoRaw)
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getFaqCategoryList({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getFaqCategoryList`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let programInfoRaw = response.data.data;
          commit("setFaqCategoryList", programInfoRaw);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getInquiryFaq({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/inquiryFaq`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          let programInfoRaw = response.data.data;
          // let faq = helpers.arrToObj(programInfoRaw, 'internalId')
          // commit('setFaq', {
          //   faq: faq,
          //   categoryCode: args.categoryCode
          // })
          // programInfoRaw.forEach(
          //   function(v){
          //     delete v.answer
          //   }
          // )
          commit("setInquiryFaq", programInfoRaw);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getInquiryFaqWithoutContent({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/inquiryFaq`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          let programInfoRaw = response.data.data;
          // let faq = helpers.arrToObj(programInfoRaw, 'internalId')
          // commit('setFaq', {
          //   faq: faq,
          //   categoryCode: args.categoryCode
          // })
          programInfoRaw.forEach(function(v) {
            delete v.answer;
          });
          commit("setInquiryFaqWithoutContent", programInfoRaw);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },


  getListCertSearchKey({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getListCertSearchKey`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setCertSearchKey", { certSearchKeyList: response.data.data });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getKecamatan({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getKecamatan`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          // commit('setKecamatan', response.data.data);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getUserType({ commit,state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .get(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getUserType`,
          {
            headers: {
              "client-source-type": "CST_WEB",
              // 'Authorization': state.tokenWeb,
              // 'user-type': state.userTypeWeb,
              
            },
          },
          {
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setUserType", response.data.data);
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getInitViewCurrProduct({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/initViewProduct`,
          {
            contractNo: userData.contractNo,
            nik: userData.nik,
            productCode: userData.productCode,
            customerTypeCode: userData.customerTypeCode,
          },
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("setInitViewCurrProduct", {
            initViewCurrProduct: response.data.data,
          });
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getInquiryPromo({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/inquiryPromo`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          //get checkout items details
          // console.log('asdffsda', userData.listCartItemId)
          // console.log('yayyyyyyy', userData)

          commit("setInquiryPromo", response.data.data);
          // commit('updateAfterCheckoutCart', userData.listCartItemId )
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  downloadSpajAsira({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/generateSPAJAsira`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("downloadECertSuccess");

          let file = response.data.data;
          let base64Data = file.base64Data;
          if (base64Data) {
            let fileSource = `data:application/octet-stream;base64,${base64Data}`;
            const link = document.createElement("a");
            link.href = fileSource;
            // link.setAttribute('download', `e-Receipt.pdf`);
            link.setAttribute("download", `${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  verifikasiOTPUser({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/verificationOtpUser`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  kirimUlangOTPUser({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/resendOtpUser`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          // console.log("response ResendOTP Sukses", response)
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  verifikasiOTPVa({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/virtual-account/v1/verificationOtpVa`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  changePassWithOtp({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      // commit('auth_request')
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/changePasswordWithOtp`,
          {
            login: state.usernameWeb,
            password: userData.password,
            newpassword: userData.newPassword,
          },
          {
            headers: {
              // 'Authorization': `Bearer ${localStorage.getItem('token')}`
              "client-source-type": "CST_WEB",
              "user-type": userType, //'INTERN_SLS',
              Authorization: state.tokenWeb,
              
            },
            validateStatus: function(status) {
              // return status >= 200 && status < 600; // default
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("changePassSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          // commit('logoutError')
          reject(err);
        });
    });
  },
  verificationOtpChangePass({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      // commit('auth_request')
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/verificationOtpChangePass`,
          {
            login: state.usernameWeb,
            password: userData.password,
            newpassword: userData.newPassword,
            otp: userData.otp,
          },
          {
            headers: {
              // 'Authorization': `Bearer ${localStorage.getItem('token')}`
              "client-source-type": "CST_WEB",
              "user-type": userType, //'INTERN_SLS',
              Authorization: state.tokenWeb,
              
            },
            validateStatus: function(status) {
              // return status >= 200 && status < 600; // default
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("changePassSuccess");
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          // commit('logoutError')
          reject(err);
        });
    });
  },
  acceptTermCondAfterLogin({ commit, state }) {
    return new Promise((resolve, reject) => {
      // commit('auth_request')
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/acceptTermCondAfterLogin`,
          {},
          {
            headers: {
              // 'Authorization': `Bearer ${localStorage.getItem('token')}`
              "client-source-type": "CST_WEB",
              "user-type": userType, //'INTERN_SLS',
              Authorization: state.tokenWeb,
              
            },
            validateStatus: function(status) {
              // return status >= 200 && status < 600; // default
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("changeTermCondFlag");
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          // commit('logoutError')
          reject(err);
        });
    });
  },

  salesRegistration({ commit,state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/UserDivoRegistration`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              // 'Authorization': state.tokenWeb,
              "user-type": "NON_ADMF",
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  inquiryDealer({ commit,state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/inquiryDealer`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            // 'Authorization': state.tokenWeb,
            // 'user-type': state.userTypeWeb,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  inquiryUpline({ commit,state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/inquiryUpline`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            // 'Authorization': state.tokenWeb,
            // 'user-type': state.userTypeWeb,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  inquiryPicDealer({ commit,state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/inquiryPicDealer`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              // 'Authorization': state.tokenWeb,
              // 'user-type': state.userTypeWeb,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  salesActivation({ commit,state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/UserDivoActivation`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              // 'Authorization': state.tokenWeb,
              // 'user-type': state.userTypeWeb,
              
            },
            params: {
              code: args,
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getJenisPertanggunganList({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .get(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getCoverage`, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          params: {
            coverageId: args.coverageId,
            category: args.category,
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  inquiryVehicle({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/inquiryVehicle`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  checkoutOrder({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .get(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/checkoutOrder`, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  countNotificationUnread({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .get(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/countNotificationFlagN`, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          let countNotif = response.data.countNotifFlag;
          commit("setCountNotifUnread", { countNotifUnread: countNotif });
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getWilayahList({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .get(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getVehicleLocation`, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getFungsiKendaraanList({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .get(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getVehicleFunction`, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getKondisiList({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .get(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getVehicleCondition`, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  inquiryVehiclePrice({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      // console.log('userData', userData)
      axios
        .post(
          `${prefixPath}/api/indobeauty/product/v1/${state.distType}/inquiryVehiclePrice`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getPremium({ commit, state }, args) {
    console.log("args", args);
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/GetPremium`, args, {
          headers: {
            Authorization: state.tokenWeb,
            "client-source-type": "CST_WEB",
            "user-type": userType,
            "Content-Type": "multipart/form-data",
            
          },
          validateStatus: function(status) {
            return status == 200;
          },
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getUplineByUser({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getUpline`,
          {},
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  register({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/insert`, args, {
          headers: {
            "client-source-type": "CST_WEB",
            "user-type": userType,
          },
          validateStatus: function(status) {
            return status == 200;
          },
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getProvinsiList({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .get(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getProvince`, {
          headers: {
            "client-source-type": "CST_WEB",
            "user-type": userType,            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getKelompokCabang({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .get(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getKelompokCabang`, {
          headers: {
            "client-source-type": "CST_WEB",
            "user-type": userType,            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },
  getTipeUsaha({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .get(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/getTipeUsaha`, {
          headers: {
            "client-source-type": "CST_WEB",
            "user-type": userType,            
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getKotaList({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .get(`${prefixPath}/api/indobeauty/product/v1/${state.distType}/getCities`, {
          headers: {
            "client-source-type": "CST_WEB",
            Authorization: state.tokenWeb,
            "user-type": userType,
            
          },
          params: {
            province: args,
          },
          validateStatus: (status) => status == 200,
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  addToCartCashDealer({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/SaveOrder`, args, {
          headers: {
            Authorization: state.tokenWeb,
            "client-source-type": "CST_WEB",
            "user-type": userType,
            "Content-Type": "multipart/form-data",
            
          },
          validateStatus: function(status) {
            return status == 200;
          },
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getCartItemDealerCash({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .get(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/GetCartItemDealerCash`,
          {
            headers: {
              Authorization: state.tokenWeb,
              "client-source-type": "CST_WEB",
              "user-type": userType,
              
              "Content-Type": "application/json",
            },
            params: {
              internalId: args,
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getAtasanByUserLogin({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/GetSalesSuperiorByUserLogin`,
          {},
          {
            headers: {
              Authorization: state.tokenWeb,
              "client-source-type": "CST_WEB",
              "user-type": userType,
              
              "Content-Type": "application/json",
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  submitOrderUser({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/SubmitOrder`,
          {},
          {
            headers: {
              Authorization: state.tokenWeb,
              "client-source-type": "CST_WEB",
              "user-type": userType,
              
              "Content-Type": "application/json",
            },
            params: {
              internalId: args,
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  deleteAtasan({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/DeleteSalesSuperior`,
          args,
          {
            headers: {
              Authorization: state.tokenWeb,
              "client-source-type": "CST_WEB",
              "user-type": userType,
              
              "Content-Type": "application/json",
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  addAtasan({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/AddSalesSuperior`,
          args,
          {
            headers: {
              Authorization: state.tokenWeb,
              "client-source-type": "CST_WEB",
              "user-type": userType,
              
              "Content-Type": "application/json",
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  editAtasan({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/EditSalesSuperior`,
          args,
          {
            headers: {
              Authorization: state.tokenWeb,
              "client-source-type": "CST_WEB",
              "user-type": userType,
              
              "Content-Type": "application/json",
            },
            validateStatus: function(status) {
              return status == 200;
            },
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  addUpline({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/saveUpline`, args, {
          headers: {
            Authorization: state.tokenWeb,
            "client-source-type": "CST_WEB",
            "user-type": userType,
            
            "Content-Type": "application/json",
          },
          validateStatus: function(status) {
            return status == 200;
          },
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  editUpline({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/updateUpline`, args, {
          headers: {
            Authorization: state.tokenWeb,
            "client-source-type": "CST_WEB",
            "user-type": userType,
            
            "Content-Type": "application/json",
          },
          validateStatus: function(status) {
            return status == 200;
          },
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  deleteUpline({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(`${prefixPath}/api/indobeauty/user-mgmt/v1/${state.distType}/deleteUpline`, args, {
          headers: {
            Authorization: state.tokenWeb,
            "client-source-type": "CST_WEB",
            "user-type": userType,
            
            "Content-Type": "application/json",
          },
          validateStatus: function(status) {
            return status == 200;
          },
        })
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  downloadPolisDealerCash({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getDocumentsPolicy`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          let file = response.data.data;
          let base64Data = file.url;
          if (base64Data) {
            // let pdfSource = `data:application/octet-stream;base64,${base64Data}`
            const link = document.createElement("a");
            link.href = base64Data;
            // link.setAttribute('download', `e-Receipt.pdf`);
            // link.setAttribute('download', `e-Receipt--${file.fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  submitDivoPolicy({ commit, state }, args) {
    return new Promise((resolve, reject) => {
      // console.log('ngejalanin commit startloading di action getOrder')
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/SubmitDivoPolicy`,
          args,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          // console.log('ngejalanin commit stoploading di action getOrder', response)
          commit("stopLoading");
          let orderDetailsRaw = response.data.data;
          let orderDetailItemsRaw = orderDetailsRaw.orderItems;
          let orderDetailItems = helpers.arrToObj(
            orderDetailItemsRaw,
            "internalId"
          );
          let orderSum = response.data.data.totalPriceAmt;
          let promoSum = response.data.data.totalPromoAmt;
          let totalToBePaidSum = response.data.data.totalToBePaidAmt;
          let programCode = response.data.data.programCode;
          // console.log('orderDetailItems', orderDetailItems)
          // console.log('orderSum', orderSum)
          commit("setViewOrder", {
            adminFeeSum: response.data.data.adminFeeAmt,
            orderDetails: orderDetailsRaw,
            orderSum: orderSum,
            orderDetailItems: orderDetailItems,
            promoSum: promoSum,
            totalToBePaidSum: totalToBePaidSum,
            programCode: programCode,
          });
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  getNoPolis({ commit, state }, userData) {
    return new Promise((resolve, reject) => {
      commit("startLoading");
      axios
        .post(
          `${prefixPath}/api/indobeauty/transaction/v1/${state.distType}/getNoPolis`,
          userData,
          {
            headers: {
              "client-source-type": "CST_WEB",
              Authorization: state.tokenWeb,
              "user-type": userType,
              
            },
            validateStatus: (status) => status == 200,
          }
        )
        .then((response) => {
          commit("stopLoading");
          resolve(response);
        })
        .catch((err) => {
          commit("stopLoading");
          reject(err);
        });
    });
  },

  // latest403RouteName ({ commit }) {
  //   return new Promise(() => {

  //   })
  // }
};
